"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LATEST_DATA_PACKAGES_MAX_DELAY_MS = void 0;
const __1 = require("..");
exports.DEFAULT_LATEST_DATA_PACKAGES_MAX_DELAY_MS = __1.RedstoneCommon.minToMs(1);
//# sourceMappingURL=index.js.map